"use client"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-lg border border-red-200 p-8 max-w-lg w-full mx-4">
        <h2 className="text-lg font-semibold text-red-700 mb-2">Page Error</h2>
        <p className="text-sm text-gray-600 mb-4">{error.message || "An unexpected error occurred."}</p>
        {error.digest && (
          <p className="text-xs text-gray-400 font-mono mb-4">Digest: {error.digest}</p>
        )}
        <button
          onClick={reset}
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
